export default class ValidationHelper {
	public static focusFirstError(ref, errors) {
		let i = 0;
		Object.keys(errors).forEach(key => {
			if (errors[key].length) {
				if(i == 0) {
					try{
						ref[key].focus();
					}catch(Exception){
						const element = ref[key].$el;
						const top = element.offsetTop;
						window.scrollTo(0, top);
						// ref[key].$el.scrollTop = 0;
					}
				}
				i++;
			}
		});
	}

	public static allElementsInArray(valuesToCheck, arrayToEvaluate) {
		return arrayToEvaluate.every(v => valuesToCheck.includes(v));
	}

	public static atLeastOnelementInArray(valuesToCheck, arrayToEvaluate) {
		return  valuesToCheck.some(r=> arrayToEvaluate.indexOf(r) >= 0);
	}
}
